import { render } from "./ProfileScreen.vue?vue&type=template&id=f6c10702&scoped=true"
import script from "./ProfileScreen.vue?vue&type=script&lang=js"
export * from "./ProfileScreen.vue?vue&type=script&lang=js"

import "./ProfileScreen.vue?vue&type=style&index=0&id=f6c10702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c10702"]])

export default __exports__